import React, { FunctionComponent } from 'react'
import { Dialog } from './Dialog'
import styled from 'styled-components'
import { breakpoints, spacing } from '../../../styles/styles'
import { PrimaryButton, SecondaryButton } from '../Buttons'
import { SpeechButton } from '../SpeechButton'
import { DialogCard } from './DialogCard'

const DialogTitle = styled.h1`
  margin: 0;

  @media only screen and (max-width: ${breakpoints.MEDIUM}) {
    margin-bottom: ${spacing.md};
    font-size: 1.2rem;
  }
`

const DialogText = styled.p`
  margin: 0 0 ${spacing.lg} 0;
`

const DialogActions = styled.div`
  display: flex;
  flex-direction: column;

  button {
    height: 3rem;

    &:last-of-type {
      margin: ${spacing.md} 0 0 0;
    }
  }

  @media only screen and (min-width: ${breakpoints.LARGE}) {
    margin-top: ${spacing.lg};
    flex-direction: row;
    justify-content: flex-end;

    button {
      height: 2.5rem;

      &:last-of-type {
        margin: 0 0 0 ${spacing.md};
      }
    }
  }
`

type Props = {
  show: boolean
  title: string
  description?: string
  confirmButtonText?: string
  cancelButtonText?: string
  onClose: () => void
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog: FunctionComponent<Props> = ({
  show,
  title,
  description,
  confirmButtonText,
  cancelButtonText,
  onClose,
  onConfirm,
  onCancel,
}) => {
  return show ? (
    <Dialog onClose={onClose}>
      <DialogCard>
        <DialogTitle>{title}</DialogTitle>

        <div
          style={{
            position: 'absolute',
            top: spacing.lg,
            right: spacing.md,
          }}
        >
          <SpeechButton
            text={description ? `${title}. ${description}` : title}
          />
        </div>

        {description && <DialogText>{description}</DialogText>}

        <DialogActions>
          <SecondaryButton onClick={onCancel}>
            {cancelButtonText ?? 'Nei'}
          </SecondaryButton>

          <PrimaryButton
            label={confirmButtonText ?? 'Ja'}
            onClick={onConfirm}
            isSmall={true}
          />
        </DialogActions>
      </DialogCard>
    </Dialog>
  ) : null
}
